import React, { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { updateOptIn } from '../feature/user.Slice'; 

/**
 * @module Components/Optin
 * @description OptIn est un composant qui permet à l'utilisateur de s'inscrire ou de se désinscrire de la liste de diffusion.
 * - Il utilise le hook useDispatch de 'react-redux' pour dispatcher l'action updateOptIn.
 * - Lorsque l'utilisateur coche ou décoche la case, l'action updateOptIn est dispatchée,
 * ce qui met à jour l'état optIn de l'utilisateur dans le store Redux.
 * - Ensuite, une requête HTTP POST est envoyée à l'API pour mettre à jour l'état optIn de l'utilisateur dans la base de données.
 *
 */

const apiPrefix = process.env.REACT_APP_API_PREFIX;

const OptIn = ({ username, optIn }) => {
    const dispatch = useDispatch();
    const [optInState, setOptInState] = useState(optIn);

    useEffect(() => {
        setOptInState(optIn);
    }, [optIn]);

    const handleOptInChange = async (e) => {
        const newOptIn = e.target.checked;
       // console.log('Opt-in status changing to:', newOptIn); // Debugging log
        setOptInState(newOptIn);
        dispatch(updateOptIn(newOptIn));

        const url = newOptIn ? `${apiPrefix}optin/create-contact-optin` : `${apiPrefix}optin/delete-contact-optin`;

        try {
            const response = await fetch(url, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({ email: username })
            });

            if (!response.ok) {
                //dispatch(clearUser());
                const data = await response.json();
                console.error(data.error);
            }
        } catch (error) {
            console.error('Une erreur est survenue lors de la modification de la liste de communication.');
        }
    };

    return (
        <div className="bg-gray-50 rounded-lg border border-gray-200 p-4">
            <div className="flex items-center justify-between">
                <div className="flex items-center space-x-3">
                    <input 
                        type="checkbox" 
                        id="optin-checkbox"
                        checked={optInState} 
                        onChange={handleOptInChange}
                        className="sr-only"
                    />
                    <label 
                        htmlFor="optin-checkbox" 
                        className={`flex items-center justify-center w-8 h-8 rounded-lg cursor-pointer transition-all duration-200 ${
                            optInState 
                                ? 'bg-primary text-white' 
                                : 'bg-white text-gray-400 border-2 border-gray-300 hover:border-primary'
                        }`}
                    >
                        {optInState ? (
                            <i className="fas fa-check text-sm"></i>
                        ) : (
                            <i className="fas fa-envelope text-sm"></i>
                        )}
                    </label>
                    
                    <div>
                        <p className="font-medium text-gray-900 text-sm">
                            S'abonner à la newsletter
                        </p>
                        <p className="text-xs text-gray-600">
                            Recevez nos meilleures offres
                        </p>
                    </div>
                </div>
                
                <div className={`px-2 py-1 rounded-full text-xs font-medium ${
                    optInState 
                        ? 'bg-green-100 text-green-700' 
                        : 'bg-gray-100 text-gray-600'
                }`}>
                    {optInState ? 'Abonné' : 'Non abonné'}
                </div>
            </div>
            
            {optInState && (
                <div className="mt-3 p-2 bg-green-50 border border-green-200 rounded-lg">
                    <div className="flex items-center text-green-700">
                        <i className="fas fa-check-circle mr-2 text-xs"></i>
                        <span className="text-xs">
                            Vous recevrez nos offres exclusives par email.
                        </span>
                    </div>
                </div>
            )}
        </div>
    );
};

export default OptIn;